export default "__VITE_ASSET__CHg$JSn7__"